import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PublicRoute = ({ children }) => {
  const token = useSelector((state) => state.userData.loginData.token);

  return !token ? children : <Navigate to="/" />;
};

export default PublicRoute;
